/**
 * Function to build hierarchy tree from flat list
 */
export const buildHierarchyTree = (nodes: any[], currentCompanyId: string) => {
    if (!nodes || nodes.length === 0) {
        return null;
    }

    // Normalize IDs for comparison (handle both string and GUID formats)
    const normalizeId = (id: any) => {
        if (!id) return null;
        return typeof id === 'string' ? id.toLowerCase() : id.toString().toLowerCase();
    };

    const normalizedCurrentId = normalizeId(currentCompanyId);

    // Handle both camelCase (from API) and PascalCase property names
    const getNodeId = (node: any) => node.id || node.Id;
    const getNodeName = (node: any) => node.name || node.Name;
    const getNodeDomain = (node: any) => node.domain || node.Domain;
    const getNodeParentId = (node: any) => node.parentId || node.ParentId;
    const getNodeRelationshipType = (node: any) => node.relationshipType || node.RelationshipType;

    // Find current company
    const currentCompany = nodes.find(n => normalizeId(getNodeId(n)) === normalizedCurrentId);
    if (!currentCompany) {
        return null;
    }

    // Build tree recursively - find root (company with no parent or highest level ancestor)
    const findRoot = (nodeId: any): any => {
        const normalizedNodeId = normalizeId(nodeId);
        const node = nodes.find(n => normalizeId(getNodeId(n)) === normalizedNodeId);
        if (!node || !getNodeParentId(node)) return node;
        return findRoot(getNodeParentId(node));
    };

    const root = findRoot(currentCompanyId);
    if (!root) {
        return null;
    }

    // Build tree recursively starting from root
    const buildNode = (node: any): any => {
        const normalizedNodeId = normalizeId(getNodeId(node));
        const children = nodes.filter(n => {
            const normalizedParentId = normalizeId(getNodeParentId(n));
            return normalizedParentId === normalizedNodeId;
        });
        
        return {
            id: getNodeId(node),
            name: getNodeName(node),
            domain: getNodeDomain(node),
            levelLabel: getNodeRelationshipType(node) || (normalizeId(getNodeId(node)) === normalizedCurrentId ? 'Current company' : ''),
            isCurrent: normalizeId(getNodeId(node)) === normalizedCurrentId,
            children: children.map(child => buildNode(child))
        };
    };

    return buildNode(root);
};

